import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const IT_SERVICES_DOMAIN_INTRO = {
  title: "IT & Technology Services",
  content: "Document AI + RPA and workflow automation across IT Operations. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "IT & Technology Services automation use cases — document AI + RPA and workflow automation across IT Operations. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "ITSM, DevOps, SIEM, CRM, Document Management, Email, Power BI";

const RAW = [
  {
    id: "access-request-automation",
    subIndustry: "IT Operations",
    department: "Identity",
    businessProcess: "Access request automation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Access request automation",
    title: "Access Request Automation Automation for IT & Technology Services",
    seoKeywords: "it & technology services, access request automation, AI automation, RPA, agentic AI",
    challenge: "Access requests are manually validated against role, manager approval and policy rules.",
    solution: "Implement RPA + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "RPA + Workflow Automation",
    buyerPersona: "IT Operations Head, CISO",
    systems: "IAM, ITSM, HRMS, Email, Directory",
    agentsRequired: "RPA Posting Agent, Access Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and access request automation process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for access request automation",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const IT_SERVICES_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["IT Operations"];
export const IT_SERVICES_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => IT_SERVICES_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'it-technology-services-domain',
  domainIntro: IT_SERVICES_DOMAIN_INTRO,
  useCases: IT_SERVICES_USE_CASES,
});
export const IT_SERVICES_USE_CASES_SEO = seo.useCasesSeo;
export const IT_SERVICES_DOMAIN_FAQS = seo.domainFaqs;
export const IT_SERVICES_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const IT_SERVICES_FAQ_JSONLD = seo.faqJsonLd;
export const IT_SERVICES_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const IT_SERVICES_WEBPAGE_JSONLD = seo.webPageJsonLd;

